export const LYRICS_RECONNECTING_TOAST_ID = 'LYRICS_RECONNECTING_TOAST_ID';
